export const apiUrl =
  import.meta.env.VITE_API_URL || 'http://localhost:8000/api';

export const apiUrlV2 = import.meta.env.VITE_API_URL_V2 || '/api';

export const centinelUrl =
  import.meta.env.VITE_API_CENTINEL_URL ||
  'https://centinelapistag.cardinalcommerce.com';

export const environment = import.meta.env.VITE_ENVIRONMENT || 'dev';

export const colours = {
  greyish: '#D0CECD',
  lightenedGrey: '#EEEEEE',
  foggy: '#757575',
  darkGrey: '#494949',
  sunSetBlue: '#0C0D34',
  white: '#FCFCFC',
  black: '#212121',
  cashiaBlue: '#00A4D4',
  absoluteWhite: '#FFFFFF',
  smoothRed: '#DC1F5C',
  dividerGrey: '#E6E5E5',
  grenish: '#21AA47',
  yellowishWhite: '#d5d5d5',
  darkWhite: '#a2a1a0',
  bgGrey: '#E6E5E5',
  lightGrey: '#F7F7F7',
  iconsGreen: '#06C7CA',
  lightGreen: '#00B097',
  trueBlack: '#000000',
  lazyRed: '#C8171D',
  red: '#FF0000',
  orange: '#FFA500',
  yellow: '#FFFF00',
  green: '#008000',
  blue: '#0000FF',
  purple: '#4B0082',
  avataPurple: '#92ACDF',
  avataGrey: '#CEDAF0',
  lightBlue: '#F3F6F9',
  lightRed: '#ECE4E9',
  modalPurpleBackDropBg: 'rgba(12, 13, 52, 0.8)',
  naviBlue: '#CCF3FF',
  light: '#ededed',
  orangeish: '#FF5733',
  lightPink: '#FCEDEC',
  veryLightBlue: '#E1E7EA',
  lightYellow: '#F29339',
};
